module.exports = __webpack_public_path__ + "media/mypage/images/jisseki/jisseki03_sp-dbcb41d2ce9f32e4d949a50332c80728.jpg";